import { render, staticRenderFns } from "./accessible-resource-item.vue?vue&type=template&id=f6045bb6&"
import script from "./accessible-resource-item.vue?vue&type=script&lang=ts&"
export * from "./accessible-resource-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports